import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { PolicyViolation } from '../../../components/policy-violation'

function PolicyViolationBridge({
  organizationId,
  organizationRole,
  violations
}) {
  return (
    <PolicyViolation
      organizationID={organizationId}
      organizationRole={organizationRole}
      violations={violations.map((violation) => ({
        id: violation.policy_id,
        name: violation.name
      }))}
    />
  )
}
export const reactRemediationPolicyViolationWarning =
  createNgReactBridgeDirective(
    'reactRemediationPolicyViolationWarning',
    [],
    PolicyViolationBridge,
    ['organizationId', 'organizationRole', 'violations']
  )
